export default class MoldData
{
    /**
     * Used for from when we start paying the mold
     */
    ImportDate = null;
    /**
     * Not used for from when we start paying the mold
     */
    PaymentDate = null;
    Factory = '';
    Name = '';
    Price = 0;
    YenConversion = 1;
    FilterLetter = '';
}